angular
	.module 'App.Service'
	.factory 'CredentialsManager', ['localStorageService', (localStorageService) ->
		class CredentialsManager
			clear: ->
				localStorageService.clearAll 'auth'

			setResourceToken: (token) ->
				localStorageService.set 'auth.resource_token', token

			getResourceToken: ->
				return localStorageService.get 'auth.resource_token'

			setAccessToken: (token) ->
				localStorageService.set 'auth.access_token', token

			getAccessToken: ->
				return localStorageService.get 'auth.access_token'

			setAccessTokenExpireTime: (expiresIn) ->
				localStorageService.set 'auth.expire_time', Date.now() + (parseInt(expiresIn) * 1000)

			getAccessTokenExpireTime: ->
				localStorageService.get 'auth.expire_time'

			setRefreshToken: (token = null) ->
				localStorageService.set 'auth.refresh_token', token

			getRefreshToken: ->
				localStorageService.get 'auth.refresh_token'

			setReferrer: (referrer = null) ->
				localStorageService.set 'referrer', referrer

			getReferrer: ->
				localStorageService.get 'referrer'

			setIdentifier: (identifier = null) ->
				localStorageService.set 'auth.identifier', identifier

			getIdentifier: ->
				localStorageService.get 'auth.identifier'

			setId: (masterUserId) ->
				localStorageService.set 'auth.id', masterUserId

			getId: ->
				localStorageService.get 'auth.id'

			injectResourceToken: (config = {}) ->
				token = @getResourceToken()

				if _.isEmpty token
					console.error('No Resource token set')

					return config

				config.params ?= {}
				config.params.access_token = token

			injectAccessToken: (config = {}) ->
				token = @getAccessToken()

				if _.isEmpty token
					console.error('No token set')

					return config

				config.headers ?= {}
				config.headers['Authorization'] = "Bearer #{token}"

				return config

		return new CredentialsManager()
	]
